import * as React from 'react';

import { Icon } from '@fluentui/react/lib/Icon';

export const onRenderIcon = (size: number, icon?: string) => {
  return () => <Icon iconName={icon} style={{ width: size, height: size }} />;
};
